module.exports = __webpack_public_path__ + "static/media/php.2b6914a7.svg";